import {accountKeys, assertionsValues} from './constants';

import {inherentRiskTypes} from './../../../../../util/uiconstants';
import {currentResource} from './../../../../../util/utils';

const exportToExcelLabels = currentResource.exportToExcelLabels;
const accountDesignationsLabels = currentResource.accountDesignationsLabels;

export const getColumnsToExport = (labels) => [
	{header: labels.reconciliationComponentExport.status, key: accountKeys.status},
	{header: labels.reconciliationComponentExport.primaryTeamAccountName, key: accountKeys.primaryTeamAccountName},
	{header: labels.reconciliationComponentExport.componentTeamAccountNames, key: accountKeys.componentTeamAccountName},
	{header: labels.reconciliationComponentExport.pspIndexes, key: accountKeys.pspIndexTitle},
	{header: labels.reconciliationComponentExport.designation, key: accountKeys.designation},
	{header: labels.reconciliationComponentExport.c, key: accountKeys.c},
	{header: labels.reconciliationComponentExport.eo, key: accountKeys.eo},
	{header: labels.reconciliationComponentExport.mv, key: accountKeys.mv},
	{header: labels.reconciliationComponentExport.ro, key: accountKeys.ro},
	{header: labels.reconciliationComponentExport.pd, key: accountKeys.pd},
	{header: labels.reconciliationComponentExport.comment, key: accountKeys.comment}
];

export const getDataToExport = (data, componentAccounts) => {
	let dataToExport = [];
	data?.forEach((account) => dataToExport.push(createDataObject(account, componentAccounts, true)));

	return dataToExport;
};

const createDataObject = (account, componentAccounts, primary) => {
	return {
		status: exportToExcelLabels.groupRiskStatusLabels[account.groupRiskStatusId],
		primaryTeamAccountName: primary ? account.accountName : '',
		componentTeamAccountName: primary ? '' : account.accountName,
		pspIndexes: getPspIndexesTitles(account),
		designation: getDesignationLabel(account.accountDesignation),
		c: getInherentRiskValue(account.assertions, assertionsValues.c),
		eo: getInherentRiskValue(account.assertions, assertionsValues.eo),
		mv: getInherentRiskValue(account.assertions, assertionsValues.mv),
		ro: getInherentRiskValue(account.assertions, assertionsValues.ro),
		pd: getInherentRiskValue(account.assertions, assertionsValues.pd),
		comment: account.rationale,
		listOfComponentRelatedToPrimary:
			account.relatedPrimaryAccounts && account.relatedPrimaryAccounts.length > 0
				? processRelatedAccounts(account.relatedPrimaryAccounts, componentAccounts)
				: []
	};
};

const getPspIndexesTitles = (account) => {
	if (!account.pspIndexes || account.pspIndexes.length === 0) {
		return '-';
	}
	return account.pspIndexes.map((index) => index.pspIndexTitle).join(', ');
};

const getDesignationLabel = (designationNumber) => {
	return accountDesignationsLabels[designationNumber] || '-';
};

const getInherentRiskValue = (assertions, abbreviation) => {
	const assertion = assertions.find((a) => a.assertionAbbreviation === abbreviation);
	if (assertion && inherentRiskTypes[assertion.inherentRiskTypeId]) {
		return inherentRiskTypes[assertion.inherentRiskTypeId];
	}
	return '-';
};

const processRelatedAccounts = (relatedPrimaryAccounts, componentAccounts) => {
	return relatedPrimaryAccounts
		.map((relatedAccount) => {
			const componentAccount = componentAccounts.find(
				(account) => account.accountId === relatedAccount.componentAccountId
			);
			return componentAccount ? createDataObject(componentAccount, componentAccounts, false) : null;
		})
		.filter((account) => account !== null); // it filters all null values assigned above
};
